import '/agent/_work/2/s/node_modules/@storybook/addon-knobs/dist/register.js';